import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from '../api/axios';
import { API_ENDPOINTS } from '../api/endpoint';

// Async thunk to get ad tags (public - for header display)
export const getAdTags = createAsyncThunk(
    'adTags/getAdTags',
    async (_, { rejectWithValue }) => {
        try {
            const response = await axios.get(API_ENDPOINTS.GET_AD_TAGS);
            if (response.data.success) {
                return response.data.tags;
            } else {
                return rejectWithValue(response.data.error || 'Failed to load ad tags');
            }
        } catch (error) {
            return rejectWithValue(error.response?.data?.error || error.message || 'Failed to load ad tags');
        }
    }
);

// Async thunk to get ad tags (admin - for management)
export const adminGetAdTags = createAsyncThunk(
    'adTags/adminGetAdTags',
    async (_, { rejectWithValue }) => {
        try {
            const response = await axios.get(API_ENDPOINTS.ADMIN_GET_AD_TAGS);
            if (response.data.success) {
                return response.data.tags;
            } else {
                return rejectWithValue(response.data.error || 'Failed to load ad tags');
            }
        } catch (error) {
            return rejectWithValue(error.response?.data?.error || error.message || 'Failed to load ad tags');
        }
    }
);

// Async thunk to update ad tags
export const updateAdTags = createAsyncThunk(
    'adTags/updateAdTags',
    async (data, { rejectWithValue }) => {
        try {
            const response = await axios.post(API_ENDPOINTS.ADMIN_UPDATE_AD_TAGS, data);
            if (response.data.success) {
                return response.data;
            } else {
                return rejectWithValue(response.data.error || 'Failed to update ad tags');
            }
        } catch (error) {
            return rejectWithValue(error.response?.data?.error || error.message || 'Failed to update ad tags');
        }
    }
);

const adTagsSlice = createSlice({
    name: 'adTags',
    initialState: {
        tags: [],
        loading: false,
        error: null,
        updateLoading: false,
        updateError: null
    },
    reducers: {
        clearError: (state) => {
            state.error = null;
            state.updateError = null;
        }
    },
    extraReducers: (builder) => {
        builder
            // Get ad tags
            .addCase(getAdTags.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(getAdTags.fulfilled, (state, action) => {
                state.loading = false;
                state.tags = action.payload || [];
            })
            .addCase(getAdTags.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
            })
            // Update ad tags
            .addCase(updateAdTags.pending, (state) => {
                state.updateLoading = true;
                state.updateError = null;
            })
            .addCase(updateAdTags.fulfilled, (state, action) => {
                state.updateLoading = false;
                // Reload tags after update
            })
            .addCase(updateAdTags.rejected, (state, action) => {
                state.updateLoading = false;
                state.updateError = action.payload;
            })
            // Admin get ad tags
            .addCase(adminGetAdTags.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(adminGetAdTags.fulfilled, (state, action) => {
                state.loading = false;
                state.tags = action.payload || [];
            })
            .addCase(adminGetAdTags.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
            });
    }
});

export const { clearError } = adTagsSlice.actions;
export default adTagsSlice.reducer;

